<script>
    import TabInfo from './tabInfo.svelte'
    import TabMonsters from './tabMonsters.svelte'
    import TabAddInfo from './tabAddInfo.svelte'

    export let Device, Contents, OnCapture
    let active = 1
</script>

<div class="menu">
    <div
        class="tab left" on:click={() => active=1}
        class:active={active==1} 
    >
        <div class="txt">공략정보</div>
        <div class="bottomright"></div>
    </div>

    <div
        class="tab middle" on:click={() => active=2}
        class:active={active==2} 
    >
        <div class="topright"></div>
        <div class="txt">몬스터</div>
        <div class="bottomright"></div>
    </div>

    <div
        class="tab right" on:click={() => active=3}
        class:active={active==3} 
    >
        <div class="topright"></div>
        <div class="txt">추가정보</div>
        <div class="bottomright"></div>
    </div>
</div>

<div id='OnCapture' class="inputPage" class:OnCapture>
    {#if OnCapture}
        <TabInfo
            bind:Date={Contents.writeDate}
            bind:Nick={Contents.nickname} bind:Build={Contents.build}
            bind:Test={Contents.testCheck} bind:Blank={Contents.blankCheck}
            bind:Memo={Contents.memo} bind:View={Contents.view}
        />
        
        <TabMonsters
            bind:OnCapture
            bind:List={Contents.monsterList}
            bind:Data={Contents.monsterData}
            bind:DataCheck={Contents.data}
        />
        
        <TabAddInfo
            bind:Device
            bind:Formation={Contents.formation}
            bind:Brilliance={Contents.brilliance}
        />
    {:else if active == 1}
        <TabInfo
            bind:Date={Contents.writeDate}
            bind:Nick={Contents.nickname} bind:Build={Contents.build}
            bind:Test={Contents.testCheck} bind:Blank={Contents.blankCheck}
            bind:Memo={Contents.memo} bind:View={Contents.view}
        />
    {:else if active == 2}
        <TabMonsters
            bind:OnCapture
            bind:List={Contents.monsterList}
            bind:Data={Contents.monsterData}
            bind:DataCheck={Contents.data}
        />
    {:else if active == 3}
        <TabAddInfo
            bind:Device
            bind:Formation={Contents.formation}
            bind:Brilliance={Contents.brilliance}
        />
    {/if}
</div>

<style lang="scss"> 
    .menu {
        margin-top: 20px;
        padding: 0 15px;
        position: relative;
            
        .tab {
            width: fit-content;
            height: fit-content;
            vertical-align: top;
            .txt {
                background: $cl5;
                padding: 10px 20px 9px 20px;
                font-size: 20px;
                font-family: aggro;
                display: inline-block;
                vertical-align: top;

            }
            .topright {
                @include sideTriangle;

                border-top: 43px solid $cl5;
                border-left: 43px solid transparent;
            }
            .bottomright {
                @include sideTriangle;

                border-bottom: 43px solid $cl5;
                border-right: 43px solid transparent;
            }

            &.active {
                z-index: 10;

                .txt { background: $cl3; }
                .topright { border-top: 43px solid $cl3; }
                .bottomright { border-bottom: 43px solid $cl3; }
            }
            &:hover:not(.active) {
                cursor: pointer;
                .txt { background: $cl3; }
                .topright { border-top: 43px solid $cl3; }
                .bottomright { border-bottom: 43px solid $cl3; }
            }

            &.middle {
                position: absolute;
                top: 0px;
                left: calc(116px);
            }
            &.right {
                position: absolute;
                top: 0px;
                left: calc(116px + 43px + 97px);
            }
        }
        
        @include mobile {
            .tab {
                .txt {
                    padding: 5px 10px 4px 10px;
                    font-size: 14px;
                }
                .topright {
                    @include sideTriangle;

                    border-top: 26px solid $cl5;
                    border-left: 26px solid transparent;
                }
                .bottomright {
                    @include sideTriangle;
                    
                    border-bottom: 26px solid $cl5;
                    border-right: 26px solid transparent;
                }

                &.active {
                    .topright { border-top: 26px solid $cl3; }
                    .bottomright { border-bottom: 26px solid $cl3; }
                }
                &:hover:not(.active) {
                    .topright { border-top: 26px solid $cl3; }
                    .bottomright { border-bottom: 26px solid $cl3; }
                }

                &.middle { left: calc(73px + 15px); }
                &.right { left: calc(73px + 15px + 26px + 60.3px); }
            }
        }
    }

    .inputPage {
        background: $cl1;
        width: calc(100% - 6px - 30px);
        height: fit-content;
        margin: 0 15px;
        border: 3px solid $cl3;
    }

    .OnCapture {
        margin: 10px 0px;
        border-radius: $br1;
    }

</style>